import './App.css';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import AdminRouters from './Admin/Routers/AdminRouters';
import CustomerRouters from './User/Routers/CustomerRouters';
import 'react-toastify/ReactToastify.css';
import VendorRouter from './Vendor/Router/VendorRouter';
import EmployeeRouter from './Employee/Router/EmployeeRouter';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { logout } from "./User/State/Auth/Action";
import { syncMenuToBackend } from './config/SyncMenuToBackend';
import { authAxios } from './config/apiConfig';
import { isAdminSessionExpired } from './config/adminSession';
import { expireAdminSession, useAdminSessionGuard } from './config/useAdminSessionGuard';

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");
  const role = localStorage.getItem('role');
  useAdminSessionGuard();

  useEffect(() => {
    if (!jwt) return;

    if (role === "ADMIN" || role === "EMPLOYEE" || role === "VENDOR") {
      const refreshInterval = setInterval(async () => {
        try {
          if (role === "ADMIN" && isAdminSessionExpired()) {
            expireAdminSession(dispatch);
            return;
          }

          const refreshToken = localStorage.getItem("refreshJwt");
          if (!refreshToken) {
            dispatch(logout());
            navigate("/login");
            return;
          }

          const response = await authAxios.post('refresh', { refreshToken: refreshToken });
          const user = response?.data;
          if (user?.jwt) {
            localStorage.setItem("jwt", user?.jwt);
          } else {
            dispatch(logout());
            navigate("/login");
          }
        } catch (error) {
          dispatch(logout());
          navigate("/login");
        }

      }, 5 * 60 * 1000);
      return () => clearInterval(refreshInterval);
    }
  }, [dispatch, jwt, navigate, role]);


  useEffect(() => {
    if (role === "ADMIN" || role === "EMPLOYEE") {
      syncMenuToBackend();
    }

  }, [role]);




  // Optional: redirect if user tries to access /admin without login
  useEffect(() => {
    const currentPath = window.location.pathname;
    const protectedPaths = ["/admin", "/employee", "/vendor", "/admin/", "/employee/", "/vendor/"];

    if (!jwt && protectedPaths.some(path => currentPath.startsWith(path))) {
      navigate("/login");
    } else if (jwt && role === "CUSTOMER" && protectedPaths.some(path => currentPath.startsWith(path))) {
      navigate("/")
    }
  }, [jwt, navigate, role]);

  return (
    <div>
      <Routes>
        {/* ✅ Always public site */}
        <Route path="/*" element={<CustomerRouters />} />

        {/* ✅ Admin routes */}
        {jwt && role === "ADMIN" && (
          <>
            <Route path="/admin/*" element={<AdminRouters />} />
            {/* ❌ Block vendor & employee routes for admin */}
            <Route path="/vendor/*" element={<Navigate to="/admin/" replace />} />
            <Route path="/employee/*" element={<Navigate to="/admin/" replace />} />
          </>
        )}

        {/* ✅ Vendor routes */}
        {jwt && role === "VENDOR" && (
          <>
            <Route path="/vendor/*" element={<VendorRouter />} />
            {/* ❌ Block admin & employee routes for vendor */}
            <Route path="/admin/*" element={<Navigate to="/vendor/" replace />} />
            <Route path="/employee/*" element={<Navigate to="/vendor/" replace />} />
          </>
        )}

        {/* ✅ Employee routes */}
        {jwt && role === "EMPLOYEE" && (
          <>
            <Route path="/employee/*" element={<EmployeeRouter />} />
            {/* ❌ Block admin & vendor routes for employee */}
            <Route path="/admin/*" element={<Navigate to="/employee/" replace />} />
            <Route path="/vendor/*" element={<Navigate to="/employee/" replace />} />
          </>
        )}
      </Routes>

    </div>
  );
}

export default App;
